import { memo } from "react";

import { SWReactIcons } from "@similarweb/icons";
import type { IconName } from "@similarweb/icons";
import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { activationModalDataAutomation } from "app/pages/activation/components/GAWidget/dataAutomationKeys";
import { ActivationModalTexts } from "app/pages/activation/components/GAWidget/texts";

import * as SC from "./styles";

type ActivationOptionSchema = {
    onClick: () => void;
    title: string;
    description: string;
    iconName: IconName;
    isDisabled?: boolean;
    isLoading?: boolean;
};

export const ActivationOption = memo(
    ({ title, description, onClick, iconName, isDisabled, isLoading }: ActivationOptionSchema) => {
        return (
            <SC.OptionContainer
                onClick={isDisabled ? undefined : onClick}
                data-automation={activationModalDataAutomation.getOptionContainer(title)}
            >
                <SC.IconContainer data-automation={activationModalDataAutomation.getIconContainer(iconName)}>
                    <SWReactIcons
                        iconName={iconName}
                        size="xs"
                    />
                </SC.IconContainer>

                <SC.OptionBody>
                    <SC.OptionTitle>{title}</SC.OptionTitle>

                    <SC.OptionDescription>{description}</SC.OptionDescription>
                </SC.OptionBody>

                <Button
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                >
                    {translate(ActivationModalTexts.select)}
                </Button>
            </SC.OptionContainer>
        );
    },
);

ActivationOption.displayName = "ActivationOption";
